import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from '../screens/AdminLogin/AdminLogin'; 
import Register from '../screens/Register/Register';
import ConfirmAccount from '../screens/AdminLogin/ConfirmAccount';
import { isAdminRegistrationEnabled } from '../utils/featureFlags';

function AdminLoginRoutes({ onLogin }) {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin onLogin={onLogin} />} />
      {isAdminRegistrationEnabled && <Route path="/register" element={<Register />} />}
      {isAdminRegistrationEnabled && <Route path="/confirm" element={<ConfirmAccount onLogin={onLogin} />} />}
      {!isAdminRegistrationEnabled && <Route path="/register" element={<Navigate to="/login" replace />} />}
      {!isAdminRegistrationEnabled && <Route path="/confirm" element={<Navigate to="/login" replace />} />}
      <Route path="*" element={<AdminLogin onLogin={onLogin} />} />
    </Routes>
  );
}

export default AdminLoginRoutes;
